import { useStorefrontContent } from '@/branding/BrandingProvider'
import { useProducts } from '@/hooks/useProducts'
import { ProductCard } from '@/components/ui/ProductCard'

export function PricingSection() {
  const { pricing } = useStorefrontContent()
  const { products } = useProducts()

  return (
    <section id="pricing" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16 reveal-base">
          <h2 className="text-3xl font-medium tracking-tight text-navy mb-4">{pricing.title}</h2>
          <p className="text-slate-600 max-w-2xl mx-auto font-light">{pricing.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {products.map((product, i) => (
            <div key={product.id} className={`reveal-base delay-${[100, 200, 300][i % 3]}`}>
              <ProductCard
                product={product}
                highlighted={product.category === 'software'}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
